import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';

import { SuiContainer } from '@splashthat/sui';
import { withFlags } from 'utils/react-context';
import { getErrorMessages } from 'common/entities/form/errorMessages';
import FormErrorMessageInput from './FormErrorMessageInput';

export const ErrorMessageEditor = (props) => (
    <SuiContainer variation="flex-vertical flex-inherit">
        {map(getErrorMessages(props.flags), (obj, key) => (
            <FormErrorMessageInput
                key={key}
                errorKey={key}
                label={obj.label}
                defaultValue={obj.value}
                setErrorMessage={props.setErrorMessage}
            />
        ))}
    </SuiContainer>
);

ErrorMessageEditor.propTypes = {
    setErrorMessage: PropTypes.func.isRequired,
    flags: PropTypes.object,
};

ErrorMessageEditor.defaultProps = {
    flags: {},
};

export default withFlags(ErrorMessageEditor);
